module.exports = __webpack_public_path__ + "static/media/hulu.62a7514c.png";